import { render, staticRenderFns } from "./MultiSelectField.vue?vue&type=template&id=535b72d2&scoped=true&"
import script from "./MultiSelectField.vue?vue&type=script&lang=ts&"
export * from "./MultiSelectField.vue?vue&type=script&lang=ts&"
import style0 from "./MultiSelectField.vue?vue&type=style&index=0&id=535b72d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535b72d2",
  null
  
)

export default component.exports